/**
 * Given an array of { question, answer } objects, return the JSON-LD of type FAQPage.
 * @param {Array<{ question: string, answer: string }>} faqs.
 */
export const generateFaqPageSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map((faq) => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});
